export const DEFAULT_HOTKEY_SCOPE = 'FrameAnno';
export const IMAGE_HOTKEY_SCOPE = 'ImageCanvas';
